import { CustomerOverview } from '../../types/customers';

export type CustomerBlockBadge = {
  text: string;
  colorScheme: 'warning' | 'secondary' | 'grey';
};

function getBlockedArtistNames(
  customer: Pick<CustomerOverview, 'blockedArtists' | 'blockedEmployeeIds'>,
): string[] {
  if (customer.blockedArtists?.length) {
    return customer.blockedArtists.map(artist => artist.name);
  }
  return (customer.blockedEmployeeIds ?? []).map(() => 'artist');
}

function formatBlockedByArtistsLabel(names: string[]): string {
  if (names.length === 1) {
    return names[0] === 'artist'
      ? 'Blocked by artist'
      : `Blocked by ${names[0]}`;
  }
  return `Blocked by ${names.join(', ')}`;
}

export function getCustomerBlockBadges({
  customer,
  isActive,
}: {
  customer: Pick<
    CustomerOverview,
    | 'shopBlocked'
    | 'artistBlocked'
    | 'isBlocked'
    | 'blockedEmployeeIds'
    | 'blockedArtists'
  >;
  isActive: boolean;
}): CustomerBlockBadge[] {
  const artistNames = getBlockedArtistNames(customer);
  const artistBlockCount = artistNames.length;
  const shopBlocked = !!customer.shopBlocked;
  const selfOrLegacyBlocked = !!(customer.artistBlocked || customer.isBlocked);

  const badges: CustomerBlockBadge[] = [];

  if (shopBlocked || selfOrLegacyBlocked) {
    badges.push({ text: 'Blocked', colorScheme: 'warning' });
  }

  if (artistBlockCount > 0) {
    const onlyOwnArtistBlock =
      !shopBlocked &&
      selfOrLegacyBlocked &&
      artistBlockCount === 1 &&
      !!customer.artistBlocked;

    if (!onlyOwnArtistBlock) {
      badges.push({
        text: formatBlockedByArtistsLabel(artistNames),
        colorScheme: 'warning',
      });
    }
  }

  if (!badges.length) {
    badges.push({
      text: isActive ? 'Active' : 'Inactive',
      colorScheme: isActive ? 'secondary' : 'grey',
    });
  }

  return badges;
}
